<template>
<div :class="'column' + checkWidth + checkOffset + checkAlign + checkMaxHeight" :style="checkMargin">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'columnWithOffset',
  computed: {
    checkWidth() {
      return this.width == 'auto' ? '' : ' is-' + this.width
    },
    checkOffset() {
      return this.offset == '0' ? '' : ' is-offset-' + this.offset
    },
    checkMargin() {
      return this.margin == '0' ? '' : 'margin-top: ' + this.margin + '%;'
    },
    checkMaxHeight() {
      return this.maxHeight == true ? ' max-height' : ''
    },
    checkAlign() {
      if (this.align == '') {
        return ''
      } else if (this.align == 'center') {
        return ' align-center'
      } else if (this.align == 'bottom') {
        return ' align-bottom'
      }
    }
  },
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    maxHeight: {
      type: Boolean,
      default: true
    },
    offset: {
      type: String,
      default: '0'
    },
    margin: {
      type: String,
      default: '0'
    },
    align: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.align-center {
  align-self: center;
}

.align-bottom {
  align-self: flex-end;
}

.max-height img {
  max-height: 100vh;
}
</style>
